import React from 'react';
import { Modal } from 'react-bootstrap';
import successImage from './assets/success.png';
import styles from './styles.scss';

function SubmitModal ({showModal, closeModal, subject}) {
  return (
    <Modal show={showModal} onHide={closeModal}>
      <Modal.Body>
        <div className={`text-center ${styles.submitModal}`}>
          <h1 className="blue">Wohoo!</h1>
          <img src={successImage} alt="successful submission" />
          <p>
            Your {subject} has been submitted!
          </p>
          <p>
            We'll be in touch shortly.
          </p>
          <button className="btn btn-dc-primary inverse" onClick={closeModal}>THANKS!</button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default SubmitModal;



// WEBPACK FOOTER //
// ./src/components/SubmitModal/index.js